import React from "react"
import ReactDOM from "react-dom"
import MerchantPageProductBanner from "./merchant-page-product-banner"

export default class MerchantPageProductBannerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.contactUsSettings = elem.dataset.contactUsSettings && JSON.parse(elem.dataset.contactUsSettings)
    self.currentPageJson = elem.dataset.currentPageJson && JSON.parse(elem.dataset.currentPageJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MerchantPageProductBanner {...self.modelJson} {...self.currentPageJson} contactUsSettings={self.contactUsSettings} />, self.elem)
  }
}
